export default __webpack_public_path__ + "src/images/reports/b_r_box.jpg";